import React from 'react'

import { Col, Grid } from '../structure/Grid'
import { SmallText } from '../presentation/Text'
import { WEEK_DAYS, useCalendar } from './CalendarHandler'
import CalendarDay from './CalendarDay'

const MonthView = () => {
  const { perspective, daysOfMonth } = useCalendar()
  if (perspective !== 'month') return false
  return (
    <Grid wrap>
      {WEEK_DAYS.map(item => (
        <Col width="14.285%" padding={0.4} key={item}>
          <SmallText size="xxxsmall" align="center" bold color="dark5">
            {item}
          </SmallText>
        </Col>
      ))}

      {daysOfMonth.map(item => (
        <CalendarDay key={item.index} {...item} />
      ))}
    </Grid>
  )
}

export default MonthView
